import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';

import { recoverUserPassword } from '../../actions';
import { reportError } from '../../../lib/error-reporter';

import PasswordResetForm from '../password-reset/form';
import PasswordResetConfirmation from '../password-reset/confirmation';

import logo from '../../img/keytravel-logo-white.png';

const COMPONENT_ID = 'DesktopPasswordResetModal';

class PasswordResetModal extends Component {

  state = {
    email: null,
    clearForm: false,
  }

  componentDidMount() {
    if (window.location.hash === '#password-reset') {
      window.$('#password-reset').modal('show');
    }

    window.$('#password-reset').on('hide.bs.modal', () => {
      window.location.hash = '#';
      this.setState({
        clearForm: true,
      });
    });
  }

  onClearForm = () => {
    this.setState({
      clearForm: false,
    });
  }

  onLoginClick = () => {
    this.hideThisModal();
    window.$('#signin').modal('show');
  }

  hideThisModal = () => {
    window.$('#password-reset').modal('hide');
    window.$('.modal-backdrop').hide();
    window.location.hash = '#';
    this.setState({
      clearForm: true,
    });
  }

  onSubmit = ({ email }) => {
    return this.props.recoverUserPassword({ email }, email)
      .then(() => this.showConfirmation(email))
      .catch((error) => {
        reportError({
          error,
          component: COMPONENT_ID,
          params: { email },
        });

        throw new SubmissionError({
          _error: error.message,
        });
      });
  }

  onSendAgainClick = () => {
    this.setState({ email: null });
  }

  showConfirmation(email) {
    this.setState({ email });
  }

  render() {
    return (
      <div className="accounts-modal modal" id="password-reset">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title pb-0 d-block w-100 text-center">
                <img src={logo} alt="Pay by group" height="24" />
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => this.hideThisModal()}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </h5>
            </div>
            <div className="modal-body">
              {
                this.state.email ?
                  <PasswordResetConfirmation
                    email={this.state.email}
                    onSendAgainClick={this.onSendAgainClick}
                  />
                  :
                  <PasswordResetForm
                    onLoginClick={this.onLoginClick}
                    onSubmit={this.onSubmit}
                    clearForm={this.state.clearForm}
                    onClearForm={this.onClearForm}
                  />
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, { recoverUserPassword })(PasswordResetModal);



// WEBPACK FOOTER //
// ./src/desktop/components/password-reset-modal/index.js